import { render, staticRenderFns } from "./AvContractBasicInfoForm.vue?vue&type=template&id=e486da6e&"
import script from "./AvContractBasicInfoForm.vue?vue&type=script&lang=js&"
export * from "./AvContractBasicInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AvContractBasicInfoForm.vue"
export default component.exports